<template>
  <ul>
    <!-- 会议管理 -->
    <li @click="RouteGo(item.name)" v-for="(item, i) in management" :key="i">
      <!-- <i class="icon i_game"></i><span>{{ item.title }}</span> -->
      <i :class="[(icon = item.icon)]"></i><span>{{ item.title }}</span>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      management: [],// 功能管理数据

    }
  },
  methods: {
    async getManagement() {
      const data = await this.PublicApi("/admin/setting/navList")
      // console.log("子组件");
      // 已选功能显示
      this.management = data.data.myNav
    },
  },
  created() {
    this.getManagement();
  }
}
</script>


// WEBPACK FOOTER //
// src/components/CommonMenu/index.vue